var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("form", [
          _c("div", { staticClass: "panel panel-grey" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c(
                "div",
                { staticClass: "form-horizontal" },
                [
                  _c("create-user", { ref: "createUser" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 col-lg-6" },
                      [
                        _c("field-input", {
                          attrs: {
                            model: _vm.$v.company,
                            "field-name": _vm.$options.filters.sentenceCase(
                              _vm.$t("organisation")
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12 col-lg-6" },
                      [
                        _c("field-input", {
                          attrs: {
                            model: _vm.$v.position,
                            "field-name": "Job Title",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-footer" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    attrs: {
                      type: "submit",
                      click: _vm.handleAddManagerCallback,
                    },
                  },
                  [_vm._v("\n              Add Manager\n            ")]
                ),
                _vm._v(" "),
                _vm.$vlastMode && _vm.$userIsAdmin
                  ? _c(
                      "div",
                      { staticClass: "checkbox checkbox-primary pull-right" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.send_activation_email.$model,
                              expression: "$v.send_activation_email.$model",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "send_activation_email",
                            id: "send_activation_email",
                          },
                          domProps: {
                            checked: Array.isArray(
                              _vm.$v.send_activation_email.$model
                            )
                              ? _vm._i(
                                  _vm.$v.send_activation_email.$model,
                                  null
                                ) > -1
                              : _vm.$v.send_activation_email.$model,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.$v.send_activation_email.$model,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.$v.send_activation_email,
                                      "$model",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.$v.send_activation_email,
                                      "$model",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.$v.send_activation_email,
                                  "$model",
                                  $$c
                                )
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "send_activation_email" } },
                          [
                            _vm._v(
                              "\n                Send Activation Email To Manager\n              "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Add Manager")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }